import { render } from "./OrderPlacement.vue?vue&type=template&id=288fcfb2"
import script from "./OrderPlacement.vue?vue&type=script&lang=js"
export * from "./OrderPlacement.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tom/tom/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__